<div  style="margin-top: 75px;">
    <form>
        <div class="row">
            <div class="col-md-3">
                <label for="bpStartDate">Fecha de Inicio</label>
                <input type="date" class="form-control form-control-sm" #bpStartDate required [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" name="bpStartDate">
            </div>
            <div class="col-md-3">
                <label for="bpEndDate">Fecha Final</label>
                <input type="date" class="form-control form-control-sm" #bpEndDate required [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" name="bpEndDate">
            </div>
            <div class="col-md-2">
                <label>Tipo de Socio.</label>
                <select class="form-control form-control-sm" [(ngModel)]="bpType" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let item of bpTypeList" [value]="item.type">{{item.name}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <label>Estado del Socio.</label>
                <select class="form-control form-control-sm" [(ngModel)]="bpStatus" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let item of bpStatusList" [value]="item.type">{{item.name}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <input style="visibility: collapse" />
                <button type="button" class="btn btn-outline-info" (click)='getBP()'>Consultar</button>
            </div>
        </div>
    </form>
</div>